export const defaultOptions = {
    delimiter: ['{', '}'],
};
